<template>
  <transition
    enter-active-class="transition-collapse__enter-active"
    leave-active-class="transition-collapse__leave-active"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  props: {
    isWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * @param {HTMLElement} element
     */
    beforeEnter (element) {
      requestAnimationFrame(() => {
        if (this.isWidth) {
          if (!element.style.width) {
            element.style.width = '0px'
          }
        } else {
          if (!element.style.height) {
            element.style.height = '0px'
          }
        }
        if (!element.style.opacity) {
          element.style.opacity = '0'
        }

        element.style.display = null
      })
    },
    /**
     * @param {HTMLElement} element
     */
    enter (element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.isWidth) {
            element.style.width = `${element.scrollWidth}px`
          } else {
            element.style.height = `${element.scrollHeight}px`
          }
          element.style.opacity = '1'
        })
      })
    },
    /**
     * @param {HTMLElement} element
     */
    afterEnter (element) {
      element.style.height = null
      element.style.opacity = null
    },
    /**
     * @param {HTMLElement} element
     */
    beforeLeave (element) {
      requestAnimationFrame(() => {
        if (this.isWidth) {
          element.style.width = `${element.offsetWidth}px`
        } else {
          if (!element.style.height) {
            element.style.height = `${element.offsetHeight}px`
          }
        }
        element.style.opacity = '1'
      })
    },
    /**
     * @param {HTMLElement} element
     */
    leave (element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.isWidth) {
            element.style.width = '0px'
          } else {
            element.style.height = '0px'
          }
          element.style.opacity = '0'
        })
      })
    },
    /**
     * @param {HTMLElement} element
     */
    afterLeave (element) {
      if (this.isWidth) {
        element.style.width = null
      } else {
        element.style.height = null
      }
      element.style.opacity = null
    },
  },
}
</script>

<style lang="scss">
  .transition-collapse {
    &__enter-active {
      overflow: hidden;
      opacity: 0;
      transition: height 200ms linear, width 200ms linear, opacity 100ms 200ms linear;
    }
    &__leave-active {
      overflow: hidden;
      transition: height 200ms 100ms linear, width 200ms 100ms linear, opacity 200ms linear;
    }
  }
</style>
